import React, { useState } from "react";
import { useContext } from "../../../context";
import { useDelete } from "../../../hooks/useDelete";

function ModalDelete() {
  const { modals, refetchAppointments, onClose } = useContext();
  const [deleteAll, setDeleteAll] = useState(false);

  const del = useDelete();

  const onDelete = () => {
    if (del.isLoading) return;
    del.initiate({ deleteAll }).then(() => {
      refetchAppointments();
      onClose();
    });
  };

  return modals.delete.isOpen ? (
    <>
      <div className="overlay"></div>
      <div
        id="filterModal"
        role="dialog"
        className="modal fade in displayBlock"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                onClick={modals.delete.close}
              >
                ×
              </button>
              <h4 className="modal-title" id="model_title">
                Are You Sure?
              </h4>
            </div>
            <div
              id="errorwindow"
              className="modal-body add-patient-form filter-patient"
            >
              Are you sure you want to delete this event?
              <div className="formInputOuter p20">
                <div className="basic-checkbox-outer col-xs-12 no-padding m-t-0">
                  <input
                    id="delete-event"
                    type="checkbox"
                    value={deleteAll}
                    name="checkAllSubsequent"
                    onChange={() => {
                      setDeleteAll(!deleteAll);
                    }}
                    checked={deleteAll ? "checked" : false}
                    className="basic-form-checkbox m-t-0"
                  />
                  <label className="basic-form-text" htmlFor="delete-event">
                    Delete all following events like this?
                  </label>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <div className="col-md-12 text-left" id="footer-btn">
                <button
                  type="button"
                  className="btn  logout pull-right"
                  data-dismiss="modal"
                  onClick={modals.delete.close}
                >
                  No
                </button>
                <button
                  type="button"
                  className="btn btn-success pull-right m-r-10"
                  data-dismiss="modal"
                  onClick={onDelete}
                  disabled={del.isLoading}
                >
                  {del.isLoading ? "Deleting..." : "Yes"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  ) : null;
}

ModalDelete.useHandler = function () {
  const [state, setState] = useState(null);

  return {
    state,
    isOpen: Boolean(state),
    open: () => {
      setState({});
    },
    close: () => {
      setState(null);
    },
  };
};

export { ModalDelete };
